import React, { useEffect, useState } from 'react';
import './LoadingScreen.scss';
import loadingAnimation from '../../../assets/icons/drp-navy-spinner.gif';
import FormatMessage from '../../../features/messages/FormatMessage';
import { useDispatch } from 'react-redux';
import { ProgressBar } from '../../ProgressBar/ProgressBar';

type Props = {
  done: boolean;
  hundredPercent: () => void;
};

let percent = 0;
let ms = 10;
let maxProgress = 60;

export const LoadingScreenSignup: React.FC<Props> = ({ done, hundredPercent }) => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const [progressText, setProgressText] = useState('hatters.signup.creatingPersonalDataServer');

  useEffect(() => {
    if (done) maxProgress = 100;
  }, [done]);

  useEffect(() => {
    if (progress < 60) {
      setProgressText('hatters.signup.creatingPersonalDataServer');
    } else if (progress < 81) {
      setProgressText('hatters.signup.customizingDatabase');
    } else {
      setProgressText('hatters.signup.personalUrlAssigned');
    }

    if (Math.round(percent) === 100) {
      hundredPercent();
    }
  }, [progress, hundredPercent, dispatch]);

  useEffect(() => {
    const progressInterval = () => {
      const interval = setInterval(() => {
        if (percent < maxProgress) {
          percent += 1;
          setProgress(percent);
        }

        if (Math.round(percent) === 100) clearInterval(interval);
      }, ms);
    };

    progressInterval();
  }, []);

  return (
    <div className={'hatters-flex-column-container loading-screen-container'}>
      <span className={'flex-spacer-small'} />

      <div className="loading-screen-wrapper">
        <img src={loadingAnimation} className={'loading-screen-icon'} alt={''} />

        <div className={'loading-screen-message'}>
          <span>
            <FormatMessage id={'hatters.signup.keepWindowOpen'} />
          </span>
          <br />

          <FormatMessage id={'hatters.signup.untilSetupIsComplete'} />
        </div>

        <ProgressBar progress={progress} />

        <div className={'loading-screen-progress-text'}>
          <FormatMessage id={progressText} />
        </div>
      </div>

      <span className={'flex-spacer-large'} />
    </div>
  );
};
